import __request__ from 'routing/request';
interface KeyStoreDtoMap {
    readonly [_key: string]: KeyStoreDto;
}
interface KeyStoreDto {
    readonly certificates: {
        readonly [_key: string]: {
            readonly subject: string;
            readonly issuer: string;
            readonly serial_number: number;
            readonly valid_from: string;
            readonly valid_to: string;
            readonly subject_alternative_names: string[];
        }[];
    };
}
/**
 * Returns the certificates used by this node
 */
export function getCertificates(): Promise<KeyStoreDtoMap> {
    return __request__('GET', '/certificates', null, {}, {
        'Accept': ['application/json']
    });
}
